import React from 'react';
import Reflux from 'reflux';
import Modal from 'shared/components/misc/modal.jsx';
import ModalActions from 'flux/actions/ModalActions';
import UIRegions from 'shared/constants/UIRegions';
import { Button } from 'bootstrap';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import CuesheetColumnActions from 'flux/actions/cuesheet/CuesheetColumnActions';
import ColumnHeader from 'main/components/show/cuesheet.responsive/columnHeader.jsx';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import Tappable from 'react-tappable';

import keyIn from 'shared/lib/immutable/keyIn';

import { NoteColumnHeaderTitle } from 'flux/stores/cuesheet/CuesheetConstants';

export default React.createClass({
  mixins: [
    Reflux.connectFilter(CuesheetStore, 'cuesheet', (st) =>
      st.filter(keyIn('columns', 'userSettings')),
    ),
  ],

  displayName: 'ColumnConfigModal',

  render() {
    if (!this.state.cuesheet.get('columns')) return null;

    return (
      <Modal
        className="csr-modal csr-column-config-modal"
        name={this._getModalId()}
        onHide={() => this._handleDone()}
        title="Column Reorder"
      >
        <div className="csr-modal-item-title-content">
          {this._getColumnListNode()}
          {this._getButtonNodes()}
        </div>
      </Modal>
    );
  },

  _handleDone() {
    ModalActions.hide(this._getModalId());
  },

  _getColumnListNode() {
    let columns = this.state.cuesheet.get('columns');

    if (!columns) return null;

    let columnNodes = columns
      .map((column) => {
        return <ColumnHeader column={column} />;
      })
      .toArray();

    return (
      <div>
        {this._getNoteHeaderNode()}
        {columnNodes}
      </div>
    );
  },

  _getNoteHeaderNode() {
    if (this._isNoteHidden()) return null;

    return (
      <div className="csr-note-cell-header clearfix">
        {NoteColumnHeaderTitle}
        {this._getNoteHideIcon()}
      </div>
    );
  },

  _getNoteHideIcon() {
    return (
      <Tappable
        className="pull-right"
        onClick={(e) => {
          e.stopPropagation();
          CuesheetColumnActions.hideNoteColumn();
        }}
      >
        <Icon size={2} name="eye-slash" />
      </Tappable>
    );
  },

  _getButtonNodes() {
    return (
      <div className="text-center btn-csr-detail-column">
        <Button onClick={() => CuesheetColumnActions.showColumns()}>
          Show All Columns
        </Button>

        {this._isNoteHidden() ? (
          <Button onClick={() => CuesheetColumnActions.showNoteColumn()}>
            Show Private Notes
          </Button>
        ) : null}
      </div>
    );
  },

  _getModalId() {
    return UIRegions.CuesheetColumnConfigMenu;
  },

  _isNoteHidden() {
    let userSettings = this.state.cuesheet.get('userSettings');
    if (!userSettings) return null;
    return userSettings.getIn(['noteColumn', 'hidden']);
  },
});
